import React, { useEffect, useState } from "react";
import { getPaginatedTransaction } from "../../features/transaction/transactionSlice";
import { useSelector, useDispatch } from "react-redux";
import TransactionTable from "./TransactionTable";
import { useNavigate } from "react-router-dom";
import { getBalance } from "../../features/transaction/transactionSlice";

function Billing() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.user);
  const [currentPage, setCurrentPage] = useState(1);

  const { loading, transactionsData } = useSelector(
    (state) => state.transactions,
  );

  useEffect(() => {
    if (user.uuid) {
      dispatch(
        getPaginatedTransaction({
          page: currentPage,
          limit: 10,
        }),
      );
    }
  }, [user.uuid, dispatch, currentPage]);

  useEffect(() => {
    dispatch(getBalance());
  }, [dispatch]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const planDetails = () => {
    navigate("/plan-details");
  };

  const manageSubscription = () => {
    navigate("/pricing");
  };

  const addCredits = () => {
    navigate("/add-credits");
  };

  return (
    <div className="container py-12">
      <div className="row">
        {/* <div className="col-5">
          <CreditsDetails
            balance={balance}
            managePlan={managePlan}
            currentPlan={organization?.subscriptionPlan}
          />
        </div> */}
        <div className="col-12">
          <TransactionTable
            transactionsData={transactionsData}
            loading={loading}
            onPageChange={handlePageChange}
            planDetails={planDetails}
            manageSubscription={manageSubscription}
            addCredits={addCredits}
          />
        </div>
      </div>
    </div>
  );
}

export default Billing;
